import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from '../../styles/FormSelectInput.module.scss';

const cx = classNames.bind(styles);

const ControlledFormSelectInput = ({
  name,
  label,
  placeholder,
  options,
  value,
  error,
  required,
  onChange,
  style,
  selectedStyle,
}) => {
  const validOption = options.find((opt) => opt.value === value);

  let finalStyle = style;
  if (validOption) {
    finalStyle = { ...finalStyle, ...selectedStyle };
  }

  return (
    <>
      {label && (
        <label htmlFor={name} className="labelText">
          {label}
          {required && <em> *</em>}
        </label>
      )}
      <select
        id={name}
        name={name}
        className={cx('ControlledFormSelectInput', { error })}
        value={validOption ? validOption.value : ''}
        onChange={(e) => onChange(e)}
        style={finalStyle}
      >
        <option disabled hidden value="">
          {placeholder}
        </option>
        {options.map((opt) => {
          return (
            <option value={opt.value} key={opt.value}>
              {opt.label}
            </option>
          );
        })}
      </select>
    </>
  );
};

ControlledFormSelectInput.defaultProps = {
  placeholder: 'Please select...',
  value: '',
  label: null,
  error: null,
  required: false,
  onChange: null,
  style: {},
  selectedStyle: {},
};

const errorShape = PropTypes.shape({
  type: PropTypes.string.isRequired,
  message: PropTypes.string,
});

const optionsShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});

ControlledFormSelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(optionsShape).isRequired,
  value: PropTypes.string,
  error: errorShape,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  selectedStyle: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default ControlledFormSelectInput;
